import { OnboardingGoals, OnboardingTask } from '../types';
import { useAddSendingDomainTask } from './tasks/useAddSendingDomainTask';
import { useGrowAudienceTask } from './tasks/useGrowAudienceTask';
import { useImportYourContactsTask } from './tasks/useImportYourContactsTask';
import { useSendEmailsViaApiTask } from './tasks/useSendEmailsViaApiTask';
import { useSendEmailsViaSmtpTask } from './tasks/useSendEmailsViaSmtpTask';
import { useSendEmailTask } from './tasks/useSendEmailTask';
import { useSendTransactionalEmailsTask } from './tasks/useSendTransactionalEmailsTask';

export const useVisibleTasksList = (onboardingGoals: OnboardingGoals): OnboardingTask[] => {
    const sendEmailTask = useSendEmailTask({ onboardingGoals });
    const importYourContactsTask = useImportYourContactsTask({ onboardingGoals });
    const sendTransactionalEmailsTask = useSendTransactionalEmailsTask({ onboardingGoals });
    const growAudienceTask = useGrowAudienceTask({ onboardingGoals });
    const sendEmailsViaSmtpTask = useSendEmailsViaSmtpTask({ onboardingGoals });
    const sendEmailsViaApiTask = useSendEmailsViaApiTask({ onboardingGoals });
    const addSendingDomain = useAddSendingDomainTask({ onboardingGoals });

    return [
        sendEmailTask,
        importYourContactsTask,
        growAudienceTask,
        addSendingDomain,
        sendTransactionalEmailsTask,
        sendEmailsViaSmtpTask,
        sendEmailsViaApiTask,
    ].filter(({ isVisible }) => isVisible);
};
